/**
 * @internal
 */
export function isURL(value) {
    return 'searchParams' in value;
}
//# sourceMappingURL=url.impl.js.map